module.exports = __webpack_public_path__ + "img/20191213165802942.c67838b5.jpg";